import React, { useState, forwardRef } from 'react';
import Type from 'prop-types';
import { Grid, InputBase, IconButton } from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";
import { Prompt } from 'react-router-dom';
import { useTranslation } from 'hooks';
import styles from './MessageInput.module.css';

const MessageInput = forwardRef(function MessageInput(props, ref) {
  const { warnAboutUnsavedChanges, onSubmit, ...other } = props;
  const [value, setValue] = useState('');
  const hasValue = value.trim().length > 0;
  const { t } = useTranslation();

  const handleChange = ({ target }) => {
    setValue(target.value);
  };

  const handleSend = () => {
    if (hasValue) {
      onSubmit(value.trim());
    }

    setValue('');
  };

  return (
    <Grid container ref={ref}>
      <Grid item xs>
        <InputBase
          value={value}
          rowsMax={6}
          onChange={handleChange}
          fullWidth
          multiline
          {...other}
        />
      </Grid>

      <Prompt when={hasValue && warnAboutUnsavedChanges} message={t('unsavedChanges')} />

      <Grid item className={styles.actions} zeroMinWidth>
        <IconButton edge="end" color="primary" aria-label={t('sendMessage')} onClick={handleSend}>
          <SendIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
});

MessageInput.propTypes = {
  warnAboutUnsavedChanges: Type.bool,
  onSubmit: Type.func.isRequired,
};

MessageInput.defaultProps = {
  warnAboutUnsavedChanges: false,
};

export default MessageInput;
